import { ApplicationState } from '@app/store'
import {
  IAccountState,
  selectAccessToken,
  selectCurrentUser,
  selectIsInitialized,
  selectPreferences,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import LoginPage from '../components/LoginPage'
import {
  actionCreators,
  ILoginState,
  selectError,
  selectIsAttemptingLogin,
  selectReturnUrl,
} from '../modules/login'

export default connect(
  createStructuredSelector<ApplicationState, IAccountState & ILoginState>({
    accessToken: selectAccessToken(),
    error: selectError(),
    isAttemptingLogin: selectIsAttemptingLogin(),
    isInitialized: selectIsInitialized(),
    preferences: selectPreferences(),
    returnUrl: selectReturnUrl(),
    user: selectCurrentUser(),
  }),
  actionCreators,
)(LoginPage)
